import { isProductionEnvironment } from 'js/helpers/environment';

export const salesforceBotConfig = isProductionEnvironment
  ? {
      init: {
        orgId: '00D4L000000iBHI',
        eswConfigDevName: 'TW_Marketplace_Chat_Web',
        siteUrl:
          'https://treatwell2021.my.site.com/ESWTWMarketplaceChatWe1712743691428',
        scrt2URL: 'https://treatwell2021.my.salesforce-scrt.com',
      },
      bootstrapJsSrc:
        'https://treatwell2021.my.site.com/ESWTWMarketplaceChatWe1712743691428/assets/js/bootstrap.min.js',
    }
  : {
      init: {
        orgId: '00DS9000006RYer',
        eswConfigDevName: 'TW_Marketplace_Chat_Web',
        siteUrl:
          'https://treatwell2021--staging.sandbox.my.site.com/ESWTWMarketplaceChatWe1712743691428',
        scrt2URL:
          'https://treatwell2021--staging.sandbox.my.salesforce-scrt.com',
      },
      bootstrapJsSrc:
        'https://treatwell2021--staging.sandbox.my.site.com/ESWTWMarketplaceChatWe1712743691428/assets/js/bootstrap.js',
    };

const uiConfig = {
  buttonPosition: {
    bottom: 20,
  },
  displayButtonOnRender: true,
  colors: {
    primaryColor: '#1859F1',
    secondaryColor: '#051230',
    botMessageBackground: '#F5F6FA',
    agentMessageBackground: '#E8EEFE',
  },
};

export const supportChatConfig = isProductionEnvironment
  ? {
      uiConfig,
      init: {
        orgId: '00D4L000000iBHI',
        eswConfigDevName: 'Marketplace_Web',
        scrt2URL: 'https://treatwell2021.my.salesforce-scrt.com',
      },
      bootstrapJsSrc:
        'https://cdn1.treatwell.net/support-chat-assets/tw-one-chat.js',
    }
  : {
      uiConfig,
      init: {
        orgId: '00DS9000006RYer',
        eswConfigDevName: 'Marketplace_Web',
        scrt2URL:
          'https://treatwell2021--staging.sandbox.my.salesforce-scrt.com',
      },
      bootstrapJsSrc:
        'https://cdn1.treatwell.net.staging.twtest.io/support-chat-assets/tw-one-chat.js',
    };
